import service from '@/base/service'
const baseURL = process.env.VUE_APP_BASE_API_AI
const request = (data) => {
  return service({ ...data, ...{ baseURL } })
}
// 商机地图查询附近园区 - HID
export function proximity (postData) {
  return request({
    url: 'technology/park/queryParkList',
    method: 'POST',
    data: postData
  })
}
// 获取园区行业具体数据
export function queryParkInfo (postData) {
  return request({
    url: 'technology/park/queryParkInfo',
    method: 'POST',
    data: postData
  })
}
// 园区企业成立年限分布
export function companyEstablishment (postData) {
  return request({
    url: 'technology/park/queryPark/companyEstablishment',
    method: 'POST',
    data: postData
  })
}
// 园区企业注册资本分布
export function companyRegisteredCapital (postData) {
  return request({
    url: 'technology/park/queryPark/companyRegisteredCapital',
    method: 'POST',
    data: postData
  })
}
// 园区公司类型数据统计
export function companyTypeCount (postData) {
  return request({
    url: 'technology/park/queryPark/companyTypeCount',
    method: 'POST',
    data: postData
  })
}